import { FormatPainterOutlined } from '@ant-design/icons';
import { Select, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { selectorMaxWidth, selectorMinWidth } from '../../constants/gridConfig';
import { useStore } from '../../store/store';
import { colorDisplayName } from '../../utils/paletteColors';
const { Option } = Select;

const ColorSelector = ({
  forcedValue,
  onChange,
  defineOpen = false,
  disableTransparent = false,
  colors,
  className,
  colorPlaceHolder,
  disabled,
  style,
  allowClear = false,
}) => {
  const { t } = useTranslation();
  const { configuration } = useStore(({ configuration }) => ({
    configuration,
  }));
  const baseColors = colors || configuration.colors;
  const displayedColors = disableTransparent
    ? baseColors.filter((color) => color.label !== 'transparent')
    : baseColors;
  return (
    <Select
      style={{
        ...style,
        maxWidth: selectorMaxWidth,
        minWidth: selectorMinWidth,
      }}
      value={forcedValue}
      placeholder={forcedValue ? null : (colorPlaceHolder || t('color'))}
      allowClear={allowClear}
      suffixIcon={<FormatPainterOutlined />}
      disabled={disabled}
      onChange={onChange}
      defaultOpen={defineOpen}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      {displayedColors.map((color) => (
        <Option key={color.label} value={color.label}>
          {/* Le nom ne s'écrit pas dans la liste (ces sélecteurs vivent dans des
              panneaux étroits) : il s'affiche au survol, y compris sur la valeur
              choisie, ce qui suffit à départager deux teintes voisines. */}
          <Tooltip title={colorDisplayName(color)} mouseLeaveDelay={0} placement='right'>
            <div
              style={{
                height: '20px',
                minHeight: '20px',
                width: '100%',
                background:
                  color.label === 'transparent'
                    ? 'linear-gradient(to top left, #FFF calc(50% - 2px), #F00, #FFF calc(50% + 2px))'
                    : color.style,
              }}
            />
          </Tooltip>
        </Option>
      ))}
    </Select>
  );
};

export default ColorSelector;
